import styled from 'styled-components/macro';

const Rotate = styled.div`
  display: inline-block;
  margin-left: 7px;
  transition: transform 0.15s ease-out;
`;

export default Rotate;
